import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

export const GetIPWhitelist = CreateProcess({
	method: "GET",
	name: "GetIPWhitelist",
	type: "IP:GETWHITELIST",

	request: () => ({
		url: "/api/authentication/ip-whitelist/",
	}),

	success: (response) => fromJS(response.data),
});

export const GetCurrentIPAddress = CreateProcess({
	method: "GET",
	name: "GetCurrentIPAddress",
	type: "IP:GETCURRENT",

	request: () => ({
		url: "/api/authentication/current-ip/",
	}),

	success: (response) => fromJS(response.data),
});

export const AddIPToWhitelist = CreateProcess({
	method: "POST",
	name: "AddIPToWhitelist",
	type: "IP:ADDTOWHITELIST",

	request: (props) => ({
		url: "/api/authentication/ip-whitelist/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const EditWhitelistObject = CreateProcess({
	method: "POST",
	name: "EditWhitelistObject",
	type: "IP:EDITWHITELISTOBJECT",

	request: (props) => ({
		url: `/api/authentication/ip-whitelist/${props.objectID}/`,
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const RemoveWhitelistItem = CreateProcess({
	method: "DELETE",
	name: "RemoveIPWhitelistItem",
	type: "IP:REMOVEWHITELISTITEM",

	request: (props) => ({
		url: `/api/authentication/ip-whitelist/${props.itemID}/`,
	}),

	success: (response) => fromJS(response.data),
});

export const changeIPWhitelistSettings = CreateProcess({
	method: "PATCH",
	name: "changeIPWhitelistSettings",
	type: "IP:WHITELISTSETTINGS",

	request: (props) => ({
		url: "/api/authentication/ip-whitelist/settings/",
		payload: {
			settings: {
				...props.settings,
			},
		},
	}),

	success: (response) => fromJS(response.data),
});
